<template>
  <button
    class="slide-action-btn"
    :class="isCollab ? 'btn-annotate' : 'btn-notes'"
    @click="openDraw">
    <i :class="isCollab ? 'el-icon-edit' : 'el-icon-document'"></i>
    <span>{{ isCollab ? 'Annotate' : 'Notes' }}</span>
  </button>
</template>
<script>
import {mapState, mapActions, mapGetters} from 'vuex'
export default {
  props: {
    title: {type: String, default: 'Annotate'},
    pic: {type: String, default: ''},
    isCollab: {type:Boolean, default: false},
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
    ...mapState(['session', 'syncUI']),
    ...mapState('teacher', ['rooms']),
    ...mapGetters(['getPage', 'getPageId']),
  },
  methods: {
    ...mapActions(['setSyncUI']),
    openDraw() {
      const pic = this.getPage?.pic || this.getPage?.url || ''
      const drawUrl = `/v2/draw/teacher/${this.rooms.sid}?pageId=${this.getPageId}&pic=${pic}` + (this.isCollab ? '&collab=true' : '')
      this.$store.commit('setSyncUI', {drawUrl})
    },
    drawOk() {
      // If we are in a demo replay session, don't trigger the global student-facing 'Join Annotation' icon
      if (this.isCollab && !this.session?.demoReplay) {
        // 本地画板已加载完成，通知其他老师端同步打开画板
        // 需要带上当前 drawUrl，否则其他老师端没有地址，DrawBox 的 v-show="syncUI.drawUrl" 仍为 false
        this.setSyncUI({drawUrl: this.syncUI.drawUrl, drawShow: true}) // Notify others to join
      } else {
        console.log('Annotation ready (Demo or Local mode - skipping student notification)')
      }
    },
    drawClose() {
      this.$store.commit('setSyncUI', {drawUrl: ''})
    }
  },
  mounted() {
    window.drawClose = this.drawClose
    if (this.isCollab) window.drawOk = this.drawOk
  },
}
</script>

<style scoped>
.slide-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;
  outline: none;
}

.btn-annotate {
  background: #00BFA5;
  border: 1px solid #00BFA5;
  color: #ffffff;
}

.btn-annotate:hover {
  background: #00a892;
  border-color: #00a892;
}

.btn-notes {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #475569;
}

.btn-notes:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #1e293b;
}

.slide-action-btn:active {
  transform: translateY(1px);
}
</style>
